import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SlideFrame } from '../SlideFrame';
import { trustSteps, trustOutcomes } from '../../data/deckContent';
export function AmbitionSlide() {
  const reduced = useReducedMotion();
  return <SlideFrame eyebrow="Strategic ambition" index={6} data-id="element-44" data-mp="1vtsfxksth4uy">
      <div data-id="element-45" data-mp="20twl4eo9yd5v">
        <h2 className="max-w-[22ch] text-[clamp(24px,3.4vw,60px)] font-semibold leading-[1.06] tracking-tight text-white" data-id="element-46" data-mp="20tn4hhp4dicu">
          From campaign recognition to{' '}
          <span className="text-[color:var(--sv-green)]" data-id="element-47" data-mp="1rut1n9l73vqu">brand trust.</span>
        </h2>

        <div className="mt-[3vh] grid grid-cols-3 gap-[1.6vw]" data-id="element-48" data-mp="1cx8zsbjligow">
          {trustSteps.map((step, i) => <motion.div key={step.order} initial={reduced ? false : {
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.35,
          delay: 0.07 * i,
          ease: 'easeOut'
        }} className={`rounded-[1.4vw] border p-[1.8vw] ${i === 2 ? 'border-[color:var(--sv-green)]/45 bg-[color:var(--sv-green)]/10' : 'border-white/10 bg-white/[0.03]'}`} data-id="element-49" data-mp="1hvka0ndsyt7n" data-mpi={i}>
              <p className="text-[clamp(9px,0.9vw,16px)] uppercase tracking-[0.28em] text-[color:var(--sv-green)]" data-id="element-50" data-mp="2jhbk3qlpwqzd">
                {step.order}
              </p>
              <p className="mt-[1.4vh] text-[clamp(13px,1.4vw,27px)] font-light leading-snug text-white" data-id="element-51" data-mp="2ek30rmou2gwj">
                {step.text}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-[3vh] flex flex-wrap items-center gap-[0.8vw]" data-id="element-52" data-mp="1lve7g9u0rfvc">
          {trustOutcomes.map(outcome => <span key={outcome} className="rounded-full border border-white/12 px-[1.2vw] py-[0.9vh] text-[clamp(10px,1.05vw,20px)] font-light text-white/65" data-id="element-53" data-mp="1vrh8fcd4x8gp">
              {outcome}
            </span>)}
        </div>

        <p className="mt-[3.2vh] text-[clamp(15px,1.9vw,36px)] font-medium leading-snug text-white" data-id="element-54" data-mp="378gz63ju3f8m">
          A little time with Solventum should always{' '}
          <span className="text-[color:var(--sv-green)]" data-id="element-55" data-mp="28tik2e5lbznu">pay back.</span>
        </p>
      </div>
    </SlideFrame>;
}